import React from "react";
import { BORDER_SOFT, BORDER_STRONG, DESTRUCTIVE, RADIUS_PILL, SAFE_BOTTOM, TABBAR_OFFSET, TAP, TEAL, TEXT } from "./tokens";

/** Height (px) a page should reserve below its content when it shows a StickyFooter. */
export const STICKY_FOOTER_HEIGHT = 76;

export interface StickyFooterProps {
  primaryLabel: string;
  onPrimary: () => void;
  primaryDisabled?: boolean;
  /** Renders the primary in the destructive red. */
  destructive?: boolean;
  /** Omit to render the primary alone. */
  cancelLabel?: string;
  onCancel?: () => void;
  /**
   * Fixed to the viewport bottom (default) above the host tab bar. Pass
   * "static" to render in flow, e.g. as the footer of a BottomSheet.
   */
  position?: "fixed" | "static";
}

/**
 * The always-visible primary action row: white background, top border
 * #EBF0F0, safe-area padding, pinned above the host's bottom tab bar via
 * --finex-tabbar-h. Buttons are 48px pills.
 */
const StickyFooter: React.FC<StickyFooterProps> = ({
  primaryLabel,
  onPrimary,
  primaryDisabled,
  destructive,
  cancelLabel,
  onCancel,
  position = "fixed",
}) => (
  <div
    className="flex items-center"
    style={{
      ...(position === "fixed"
        ? {
            position: "fixed",
            left: 0,
            right: 0,
            bottom: `calc(${TABBAR_OFFSET} + ${SAFE_BOTTOM})`,
            zIndex: 150,
          }
        : {}),
      gap: "12px",
      padding: position === "fixed" ? "12px 16px" : `12px 20px calc(12px + ${SAFE_BOTTOM})`,
      backgroundColor: "#FFFFFF",
      borderTop: `1px solid ${BORDER_SOFT}`,
      boxSizing: "border-box",
    }}
  >
    {cancelLabel && (
      <button
        type="button"
        className="font-inter"
        onClick={onCancel}
        style={{
          flex: 1,
          height: "48px",
          minWidth: `${TAP}px`,
          borderRadius: RADIUS_PILL,
          border: `1px solid ${BORDER_STRONG}`,
          backgroundColor: "#FFFFFF",
          color: TEXT,
          fontSize: "15px",
          fontWeight: 500,
          cursor: "pointer",
        }}
      >
        {cancelLabel}
      </button>
    )}
    <button
      type="button"
      className="font-inter"
      onClick={onPrimary}
      disabled={primaryDisabled}
      style={{
        flex: cancelLabel ? 1.4 : 1,
        height: "48px",
        minWidth: `${TAP}px`,
        borderRadius: RADIUS_PILL,
        border: "none",
        backgroundColor: destructive ? DESTRUCTIVE : TEAL,
        color: "#FFFFFF",
        fontSize: "15px",
        fontWeight: 600,
        opacity: primaryDisabled ? 0.45 : 1,
        cursor: primaryDisabled ? "default" : "pointer",
      }}
    >
      {primaryLabel}
    </button>
  </div>
);

export default StickyFooter;
